'use strict';

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

var lodashClone = require('lodash.clone');

/**
 * Finds the value of any given namespace
 * @param {object} options
 * @param {string} options.ns Period delimited string representing the property to search for (ie. "my.name.space")
 * @param {object} [options.parent={}] object to iterate over
 * @param {*} [options.fallback=undefined] the return value if the `options.ns` is not found
 * @param {boolean} [options.clone=false] Clone the returned value if it is an object or an array
 * @returns {*} Whatever the property value is or whatever is defined in the `options.fallback` param
 */
function fns(_ref) {
    var _ref$ns = _ref.ns;
    var ns = _ref$ns === undefined ? '' : _ref$ns;
    var _ref$parent = _ref.parent;
    var parent = _ref$parent === undefined ? {} : _ref$parent;
    var _ref$fallback = _ref.fallback;
    var fallback = _ref$fallback === undefined ? undefined : _ref$fallback;
    var _ref$clone = _ref.clone;
    var clone = _ref$clone === undefined ? false : _ref$clone;

    var namespace = ns.split('.');
    var target = parent;
    var currentNs = undefined;
    if (!target) {
        return fallback;
    }
    while (currentNs = namespace.shift()) {
        if (target === null || target === void 0) {
            // void(0) always returned `undefined`
            // used this since `undefined` can be overwritten
            // `null` and `undefined` do not have `.hasOwnProperty`
            // so short circuit this loop here instead
            return target;
        }
        if (Array.isArray(target) || typeof target === 'string') {
            // if target is an array or a string, ensure that
            // currentNs indexes within the bounds of target
            if (currentNs % 1 !== 0 || currentNs >= target.length || currentNs < 0) {
                return fallback;
            }
        } else if (!target.hasOwnProperty(currentNs)) {
            // if the target is an object but does not have the property
            return fallback;
        }
        target = target[currentNs];
    }

    return ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' || Array.isArray(target)) && clone ? lodashClone(target) : target;
}

module.exports = function findNamespaceValue() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    if (args.length === 1) {
        var arg = args[0];
        if (typeof arg === 'string') {
            // this will ultimately return `undefined`
            // since you always need a `parent`
            return fns({
                ns: arg
            });
        }
        return fns(arg);
    }

    // backwards compat - there was never a "clone" option before es6-ifying this module
    return fns({
        ns: args[0],
        parent: args[1],
        fallback: args[2]
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/find-namespace-value/dist/index.js
// module id = 289
// module chunks = 63